import { FC } from 'react';

import { Col, Row, RowProps } from 'antd';
import { TRoutesTree } from 'types/routes';

import { RouteBreadcrumbs } from '@atoms/routeBreadcrumbs';
import { RouteTabs } from '@atoms/routeTabs';
import { RouteTitle } from '@atoms/routeTitle';
import RenderIf from '@common/RenderIf';
import { useRoutesData } from '@hooks/useRoutesData';
import { OptionsMenu } from '@molecules/OptionsMenu';

import './style.scss';

const HeaderExtended: FC<RowProps> = ({ children, ...props }) => (
    <Row justify="space-between" align="middle" {...props}>
        {children}
    </Row>
);

export const RouteHeader = ({ routesTree }: { routesTree: TRoutesTree }) => {
    const routesData = useRoutesData(routesTree);

    const currentRoutes = routesData?.currentRoutes;
    const childrenRoutes = routesData?.childrenRoutes;

    const isMoreThanOneRoute = currentRoutes.length + childrenRoutes.length > 1;
    const isHasTabs = currentRoutes.some((route) => route?.custom?.isHasTab);
    const isHideTitle = currentRoutes.some((route) => route?.custom?.isHideTitle);
    const isHideBreadcrumbs = currentRoutes.some((route) => route?.custom?.isHideBreadcrumbs);

    return (
        <div className="header">
            <RenderIf condition={!isHideTitle}>
                <HeaderExtended className="header-top">
                    <Col>
                        <RouteTitle routeItems={currentRoutes} />
                    </Col>
                    <Col></Col>
                </HeaderExtended>
            </RenderIf>
            <RenderIf condition={isMoreThanOneRoute && !isHideBreadcrumbs}>
                <HeaderExtended className="header-center">
                    <Col>
                        <RouteBreadcrumbs routeItems={currentRoutes} />
                    </Col>
                    <Col>
                        <OptionsMenu routeItems={currentRoutes} />
                    </Col>
                </HeaderExtended>
            </RenderIf>
            <RenderIf condition={isHasTabs}>
                <HeaderExtended className="header-bottom">
                    <Col span={24}>
                        <RouteTabs
                            routesTree={routesTree}
                            centered={true}
                            style={{ marginBottom: -16 }}
                        />
                    </Col>
                </HeaderExtended>
            </RenderIf>
        </div>
    );
};
